import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { AuthProvider, useAuth } from "@/auth/AuthContext";
import LoginPage from "@/pages/Login";
import QuotesPage from "@/pages/Quotes";
import QuoteDetailPage from "@/pages/QuoteDetail";
import CatalogPage from "@/pages/Catalog";
import PricingPage from "@/pages/Pricing";
import SourcingPage from "@/pages/Sourcing";
import InventoryPage from "@/pages/Inventory";
import SettingsPage from "@/pages/Settings";
import ReportsPage from "@/pages/Reports";
import ReadinessPage from "@/pages/Readiness";
import OemQuotesPage from "@/pages/OemQuotes";
import OemOrdersOpenPage from "@/pages/OemOrdersOpen";

// The whole app sits behind a session. Note this gate is about what to
// RENDER, not about access: every backend endpoint checks the user's role
// itself, so bypassing this in devtools reaches an API that still refuses.
function Gate() {
  const { status } = useAuth();

  // Neither screen until the first whoami answers, otherwise an
  // already-signed-in user sees the login form flash on every page load.
  if (status === "checking") return null;
  if (status === "out") return <LoginPage />;

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Navigate to="/quotes" replace />} />
        <Route path="/quotes" element={<QuotesPage />} />
        <Route path="/quotes/:id" element={<QuoteDetailPage />} />
        {/* ONE QUOTE LIST. /quotes reads the database now, so the second
            list this route used to render is gone and the path redirects to
            it -- old links, bookmarks and the back-links below all still land
            somewhere real. */}
        <Route path="/saved-quotes" element={<Navigate to="/quotes" replace />} />
        {/* ⚠️ THE DETAIL ROUTE STAYS AT /saved-quotes/:savedId, deliberately.
            QuoteDetailPage decides "saved mode" from this param, and
            services/mockQuoteGuard.ts's Fence 1 uses the ROUTE to tell a real
            database record from a shipped example quote that shares its name.
            Renaming this path would move that fence. */}
        <Route path="/saved-quotes/:savedId" element={<QuoteDetailPage />} />
        <Route path="/catalog" element={<CatalogPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/sourcing" element={<SourcingPage />} />
        <Route path="/inventory" element={<InventoryPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/reports" element={<ReportsPage />} />
        <Route path="/readiness" element={<ReadinessPage />} />
        <Route path="/oem-quotes" element={<OemQuotesPage />} />
        <Route path="/oem-orders" element={<OemOrdersOpenPage />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Gate />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
